import type { FontOptions, FontFace } from '@/store/font/types';
import { arrayClone, arrayMap } from './nativeArray';

export const getFrameHeader = () => {
  const $gfFrameHead = jQuery('#gfFrame').contents().find('head');
  return $gfFrameHead;
};

export const writeFontFace = (styleName: string, fontFaces: FontFace[]) => {
  const fontFacesList = arrayMap(
    fontFaces,
    (item) =>
      `@font-face { font-family: ${styleName}; src: url(${item.url}); font-style: ${item.style}; font-weight: ${item.weight}; }`,
  );
  return fontFacesList.join('');
};

export const insertInstalledFontsWhenSavingFontManager = (fonts: FontOptions[]) => {
  const installedFonts = arrayClone(fonts);

  const $gfFrameHead = getFrameHeader();
  const $installFontStyles = $gfFrameHead.find('style.gf_installed-font');
  const installFontStylesLength = $installFontStyles.length;

  for (let i = 0; i < installFontStylesLength; i++) {
    const $style = $installFontStyles.eq(i);

    const fontName = $style.attr('data-font');
    let checkFont = false;

    if (fontName) {
      const installedFontsLength = installedFonts.length;

      for (let j = installedFontsLength - 1; j > -1; j--) {
        const installedFont = installedFonts[j];
        if (installedFont.styleName == fontName) {
          checkFont = true;
          break;
        }
      }
    }

    if (!checkFont) {
      $style.remove();
    }
  }

  const installedFontsLength = installedFonts.length;
  for (let i = 0; i < installedFontsLength; i++) {
    const installedFont = installedFonts[i];
    if (!installedFont.fontFaces) continue;

    $gfFrameHead.append(`
			<style class="gf_installed-font" data-font="${installedFont.styleName}">
				${writeFontFace(installedFont.styleName, installedFont.fontFaces)}
			</style>
		`);
  }
};

export const insertInstalledFontsWhenSavingPage = (fonts: FontOptions[]) => {
  const fontFacesList = arrayMap(fonts, (font) => {
    return font.fontFaces ? writeFontFace(font.styleName, font.fontFaces) : '';
  });
  return fontFacesList.join('');
};
